import MuiDialogActions from '@mui/material/DialogActions';
import { FC } from 'react';
import { Button } from '../../buttons/Button';
import { Grid } from '../../layout/grid/Grid';
import { DialogActionsProps } from './model/DialogActionsProps';

export const DialogActions: FC<DialogActionsProps> = ({
  cancelLabel = 'No',
  confirmLabel = 'Yes',
  disableConfirm,
  disableCancel,
  disabled,
  onCancel,
  onConfirm,
}) => (
  <MuiDialogActions>
    <Grid container justifyContent="center" sx={{ px: { xs: 3, sm: 7, md: 11 }, pb: 3 }}>
      {onCancel ? (
        <Grid item sm={6} xs={12} p={1}>
          <Button
            disabled={disableCancel || disabled}
            variant="outlined"
            color="primary"
            type="button"
            size="medium"
            onClick={onCancel}
            fullWidth
          >
            {cancelLabel}
          </Button>
        </Grid>
      ) : null}
      {onConfirm ? (
        <Grid item sm={6} xs={12} p={1}>
          <Button
            disabled={disableConfirm || disabled}
            variant="contained"
            color="primary"
            type="submit"
            size="medium"
            onClick={onConfirm}
            fullWidth
          >
            {confirmLabel}
          </Button>
        </Grid>
      ) : null}
    </Grid>
  </MuiDialogActions>
);
